import { render, staticRenderFns } from "./Counter.vue?vue&type=template&id=e7721fb6&scoped=true&"
import script from "./Counter.vue?vue&type=script&lang=js&"
export * from "./Counter.vue?vue&type=script&lang=js&"
import style0 from "./Counter.vue?vue&type=style&index=0&id=e7721fb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7721fb6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
